import { Component, OnInit } from "@angular/core";

@Component({
	selector: "caass-ms-notification-by-email",
	templateUrl: "./ms-notification-by-email.component.html",
	styleUrls: ["./ms-notification-by-email.component.css"],
})
export class MsNotificationByEmailComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
